// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { PostApiAccountChangepasswordData, PostApiAccountChangepasswordResponses, GetApiDashboardByKlientIdData, GetApiDashboardByKlientIdResponses, PostApiEmailSendemailData, PostApiEmailSendemailResponses, VyhledatData, VyhledatResponses, GetApiInfoData, GetApiInfoResponses, GetApiKlientGetklientlistData, GetApiKlientGetklientlistResponses, KlientDetailData, KlientDetailResponses, PrilohyKlientDetailData, PrilohyKlientDetailResponses, GetApiPingData, GetApiPingResponses, GetApiPingPingauthData, GetApiPingPingauthResponses, PojistneUdalostiData, PojistneUdalostiResponses, PojistneUdalostiVseData, PojistneUdalostiVseResponses, PojistnaUdalostData, PojistnaUdalostResponses, PrilohyPojistnaUdalostData, PrilohyPojistnaUdalostResponses, GetPrilohaData, GetPrilohaResponses, PrilohyObecneData, PrilohyObecneResponses, PrilohaKeyData, PrilohaKeyResponses, DownloadPrilohaData, DownloadPrilohaResponses, SmlouvyListData, SmlouvyListResponses, SmlouvaDetailData, SmlouvaDetailResponses, PodsmlouvyListData, PodsmlouvyListResponses, PodsmlouvaDetailData, PodsmlouvaDetailResponses, PlatbyListData, PlatbyListResponses, PrilohySmlouvaDetailData, PrilohySmlouvaDetailResponses, PrilohyPodsmlouvaDetailData, PrilohyPodsmlouvaDetailResponses, PostApiUploadData, PostApiUploadResponses, PostApiUploadDeleteByUidData, PostApiUploadDeleteByUidResponses, ZpravyListData, ZpravyListResponses, ZpravySmlouvaListData, ZpravySmlouvaListResponses, ZpravyPodsmlouvaListData, ZpravyPodsmlouvaListResponses, ZpravyPojistnaUdalostListData, ZpravyPojistnaUdalostListResponses, ZpravaDetailData, ZpravaDetailResponses, ZpravaInsertData, ZpravaInsertResponses, PrilohyUkolDetailData, PrilohyUkolDetailResponses, ZpravaStatusData, ZpravaStatusResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Změna hesla uživatele
 */
export const postApiAccountChangepassword = <ThrowOnError extends boolean = false>(options?: Options<PostApiAccountChangepasswordData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiAccountChangepasswordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/account/changepassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Dashboard
 */
export const getApiDashboardByKlientId = <ThrowOnError extends boolean = false>(options: Options<GetApiDashboardByKlientIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDashboardByKlientIdResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/dashboard/{klientId}',
        ...options
    });
};

/**
 * Odeslání testovacího mailu - pouze pro účely testování
 */
export const postApiEmailSendemail = <ThrowOnError extends boolean = false>(options?: Options<PostApiEmailSendemailData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiEmailSendemailResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/email/sendemail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Vyhledávání
 */
export const vyhledat = <ThrowOnError extends boolean = false>(options: Options<VyhledatData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<VyhledatResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/vyhledat/{text}',
        ...options
    });
};

/**
 * Informace o verzi a nasazeni api
 */
export const getApiInfo = <ThrowOnError extends boolean = false>(options?: Options<GetApiInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiInfoResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/info',
        ...options
    });
};

/**
 * Seznam klientů přihlášeného uživatele
 */
export const getApiKlientGetklientlist = <ThrowOnError extends boolean = false>(options?: Options<GetApiKlientGetklientlistData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiKlientGetklientlistResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/klient/getklientlist',
        ...options
    });
};

/**
 * Detail klienta + adresy
 */
export const klientDetail = <ThrowOnError extends boolean = false>(options: Options<KlientDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<KlientDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/klient/detail/{klientID}',
        ...options
    });
};

/**
 * Seznam příloh k detailu klienta
 */
export const prilohyKlientDetail = <ThrowOnError extends boolean = false>(options: Options<PrilohyKlientDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohyKlientDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/klient/detail/{klientId}/prilohy',
        ...options
    });
};

/**
 * Vrátí stav serveru
 */
export const getApiPing = <ThrowOnError extends boolean = false>(options?: Options<GetApiPingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiPingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ping',
        ...options
    });
};

/**
 * Vrátí stav serveru
 */
export const getApiPingPingauth = <ThrowOnError extends boolean = false>(options?: Options<GetApiPingPingauthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiPingPingauthResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ping/pingauth',
        ...options
    });
};

/**
 * Seznam pojistných událostí smlouvy.
 */
export const pojistneUdalosti = <ThrowOnError extends boolean = false>(options: Options<PojistneUdalostiData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PojistneUdalostiResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouva/{typ}/{smlouvaId}/pojistneudalosti',
        ...options
    });
};

/**
 * Seznam všech pojistných událostí
 */
export const pojistneUdalostiVse = <ThrowOnError extends boolean = false>(options: Options<PojistneUdalostiVseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PojistneUdalostiVseResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/pojistneudalosti',
        ...options
    });
};

/**
 * Detail pojistné události
 */
export const pojistnaUdalost = <ThrowOnError extends boolean = false>(options: Options<PojistnaUdalostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PojistnaUdalostResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/pojistnaudalost/{udalostId}',
        ...options
    });
};

/**
 * Seznam příloh k detailu smlouvy
 */
export const prilohyPojistnaUdalost = <ThrowOnError extends boolean = false>(options: Options<PrilohyPojistnaUdalostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohyPojistnaUdalostResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/pojistnaudalost/{udalostId}/prilohy',
        ...options
    });
};

/**
 * Stažení přílohy
 * @deprecated
 */
export const getPriloha = <ThrowOnError extends boolean = false>(options: Options<GetPrilohaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPrilohaResponses, unknown, ThrowOnError>({
        responseType: 'blob',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/priloha/{uid}',
        ...options
    });
};

/**
 * Seznam obecných příloh (přilohy typu formuláře, povinné dokumenty o firmě atd ...)
 */
export const prilohyObecne = <ThrowOnError extends boolean = false>(options?: Options<PrilohyObecneData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PrilohyObecneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/prilohy/list',
        ...options
    });
};

/**
 * Generování klíče pro stažení přílohy
 */
export const prilohaKey = <ThrowOnError extends boolean = false>(options: Options<PrilohaKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohaKeyResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/priloha/key/{prilohaUID}',
        ...options
    });
};

/**
 * Stažení souboru
 */
export const downloadPriloha = <ThrowOnError extends boolean = false>(options: Options<DownloadPrilohaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadPrilohaResponses, unknown, ThrowOnError>({
        responseType: 'blob',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/priloha/get/{guid}',
        ...options
    });
};

/**
 * Seznam smluv klienta
 */
export const smlouvyList = <ThrowOnError extends boolean = false>(options: Options<SmlouvyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SmlouvyListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouvy',
        ...options
    });
};

/**
 * Detail samostatné smlouvy + atributy + rizika
 */
export const smlouvaDetail = <ThrowOnError extends boolean = false>(options: Options<SmlouvaDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SmlouvaDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouva/{typ}/{smlouvaId}',
        ...options
    });
};

/**
 * Detail rámcové smlouvy - Seznam podsmluv
 */
export const podsmlouvyList = <ThrowOnError extends boolean = false>(options: Options<PodsmlouvyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PodsmlouvyListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouva/r/{smlouvaId}/podsmlouvy',
        ...options
    });
};

/**
 * Detail podsmlouvy (ramcové, nebo kasko ) - atributy + rizika
 */
export const podsmlouvaDetail = <ThrowOnError extends boolean = false>(options: Options<PodsmlouvaDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PodsmlouvaDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/podsmlouva/{atributPmvID}',
        ...options
    });
};

/**
 * Seznam plateb k detailu smlouvy
 */
export const platbyList = <ThrowOnError extends boolean = false>(options: Options<PlatbyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PlatbyListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouva/{smlouvaId}/platby',
        ...options
    });
};

/**
 * Seznam příloh k detailu smlouvy
 */
export const prilohySmlouvaDetail = <ThrowOnError extends boolean = false>(options: Options<PrilohySmlouvaDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohySmlouvaDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/smlouva/{smlouvaId}/prilohy',
        ...options
    });
};

/**
 * Seznam příloh k detailu podsmlouvy (atributu smlouvy)
 */
export const prilohyPodsmlouvaDetail = <ThrowOnError extends boolean = false>(options: Options<PrilohyPodsmlouvaDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohyPodsmlouvaDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/podsmlouva/{atributID}/prilohy',
        ...options
    });
};

/**
 * Nahrání souboru do temp složy
 */
export const postApiUpload = <ThrowOnError extends boolean = false>(options?: Options<PostApiUploadData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiUploadResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Odstranění souboru z temp složky
 */
export const postApiUploadDeleteByUid = <ThrowOnError extends boolean = false>(options: Options<PostApiUploadDeleteByUidData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiUploadDeleteByUidResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/upload/delete/{uid}',
        ...options
    });
};

/**
 * Seznam všech zpráv
 */
export const zpravyList = <ThrowOnError extends boolean = false>(options: Options<ZpravyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ZpravyListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zpravy',
        ...options
    });
};

/**
 * Seznam zpráv k samostané, nebo kasko smlouvě
 */
export const zpravySmlouvaList = <ThrowOnError extends boolean = false>(options: Options<ZpravySmlouvaListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ZpravySmlouvaListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zpravy/smlouva/{id}',
        ...options
    });
};

/**
 * Seznam zpráv k detailu podsmlouvy
 */
export const zpravyPodsmlouvaList = <ThrowOnError extends boolean = false>(options: Options<ZpravyPodsmlouvaListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ZpravyPodsmlouvaListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zpravy/podsmlouva/{id}',
        ...options
    });
};

/**
 * Seznam zpráv k detailu pojitné události
 */
export const zpravyPojistnaUdalostList = <ThrowOnError extends boolean = false>(options: Options<ZpravyPojistnaUdalostListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ZpravyPojistnaUdalostListResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zpravy/pojistnaudalost/{id}',
        ...options
    });
};

/**
 * Detail zprávy
 * @deprecated
 */
export const zpravaDetail = <ThrowOnError extends boolean = false>(options: Options<ZpravaDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ZpravaDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zprava/{id}',
        ...options
    });
};

/**
 * Insert zprávy (úkolu)
 */
export const zpravaInsert = <ThrowOnError extends boolean = false>(options: Options<ZpravaInsertData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ZpravaInsertResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zprava/insert',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Seznam příloh k detailu zprávy
 */
export const prilohyUkolDetail = <ThrowOnError extends boolean = false>(options: Options<PrilohyUkolDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PrilohyUkolDetailResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zprava/{ukolId}/prilohy',
        ...options
    });
};

/**
 * Editace statusu úkolu - status 20 (přečteno), 30 (archiv)
 */
export const zpravaStatus = <ThrowOnError extends boolean = false>(options: Options<ZpravaStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ZpravaStatusResponses, unknown, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/{klientId}/zprava/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};